import { leagueFetch } from '@leagueplatform/league-fetch';

type Value =
  | {
      type: 'value-quantity';
      [key: string]: string | number;
    }
  | {
      type: 'value-enum';
      [key: string]: string | number;
    }
  | {
      type: 'value-period';
      start: string;
      end: string;
    };

export type HealthMetricPostData = {
  metricConfigId: string;
  metricComponentId: string;
  effectiveDateTime?: string;
  value: Value;
};

// TODO: Will be used once the backend is ready.
// export async function createHealthMetricsBatch(data: HealthMetricPostData[]) {
//   const response = await leagueFetch('v3/health-metrics-batch', {
//     method: 'POST',
//     body: JSON.stringify({
//       data: {
//         type: 'health-metrics-batch',
//         attributes: {
//           entries: data,
//         },
//       },
//     }),
//   });
//
//   if (!response.ok) {
//     throw new Error(`PostCreateHealthMetricsBatch error: ${response.status}`);
//   }
// }

async function createHealthMetricsLegacy(data: HealthMetricPostData[]) {
  const requests = data.map((datum) =>
    leagueFetch('v3/health-metrics', {
      method: 'POST',
      body: JSON.stringify({
        data: {
          type: 'health-metric',
          attributes: datum,
        },
      }),
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`PostCreateHealthMetrics error: ${response.status}`);
      }
      return response;
    }),
  );

  await Promise.all(requests);
}

export const createHealthMetrics = createHealthMetricsLegacy;
